export function PawMark({ className = "w-9 h-9" }) {
  return (
    <img
      src="/images/logo-london.webp"
      alt="Pet Taxi London logo"
      className={`${className} rounded-full object-cover ring-1 ring-white/25`}
    />
  );
}

export function Logo({ dark = false }) {
  return (
    <span className="flex items-center gap-2.5">
      <PawMark />
      <span className="leading-none">
        <span className={`block font-serif text-lg font-semibold tracking-tight ${dark ? "text-champagne" : "text-ink"}`}>
          Pet Taxi London
        </span>
        <span className="block font-mono text-[10px] tracking-[0.22em] text-[#A9C29A] uppercase mt-0.5">
          London ↔ Europe
        </span>
      </span>
    </span>
  );
}
